import React from 'react';
import { Spring, animated } from 'react-spring';

import styles from './style.css';

const JobsIOSJunior = () => (
  <div className={styles.jobs}>
    <Spring
      native
      from={{ opacity: 0, transform: 'translateX(-50%)' }}
      to={{ opacity: 1, transform: 'translateX(0%)' }}
    >
      {style => (
        <animated.div style={style} className={styles.jobs__text__wrapper}>
          <div className={styles.jobs_text}>
            Junior <span>iOS</span> Developer
          </div>
        </animated.div>
      )}
    </Spring>
    <Spring native from={{ opacity: 0 }} to={{ opacity: 1 }} delay={500}>
      {style => (
        <animated.div style={style} className={styles.jobs__description}>
          <p>
            Play a key role in developing native iOS apps for amazing clients
            from around the world; join our team in the heart of Cluj-Napoca and
            deliver for the best at an agency recognized by Apple.
          </p>
          <p>
            <strong>Requirements</strong> 1+ years experience building iOS apps
            / strong oop knowledge / attention to detail / strong interaction
            and design sense
          </p>
          <a
            className={styles.apply__button}
            href="mailto:hello@wearewip.com?Subject=iOS Developer Job Application"
          >
            Apply Now
          </a>
        </animated.div>
      )}
    </Spring>
  </div>
);

export default JobsIOSJunior;
